import { useFetchPublicApi } from '~/composables/fetch/fetchComposables'
import { contentServiceURL } from './apiDomain'
// import { createHttp } from './http'

export default {
  getGalleryPage(slug: string) {
    return useFetchPublicApi.get(`${contentServiceURL}/pages${slug}`, {}, {
      baseURL: process.server ? useRuntimeConfig().localProductContentUrl : useAppConfig().baseApiUrl
    })
  },
  getBlogPost(params: any) {
    return useFetchPublicApi.get(`${contentServiceURL}/get-blog-posts`, params, {
      baseURL: process.server ? useRuntimeConfig().localProductContentUrl : useAppConfig().baseApiUrl
    })
  },
  getTripList(url: string, params: any) {
    return useFetchPublicApi.get(`${contentServiceURL}/${url}`, params, {
      watch: false,
      baseURL: process.server ? useRuntimeConfig().localProductContentUrl : useAppConfig().baseApiUrl
    })
  },
  getQuickLinks(params: any) {
    return useFetchPublicApi.get(`${contentServiceURL}/destinations/quick-links`, params, {
      baseURL: process.server ? useRuntimeConfig().localProductContentUrl : useAppConfig().baseApiUrl
    })
  },
}
